import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=fd003a02&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=fd003a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd003a02",
  null
  
)

export default component.exports